import { commonSpinner } from '@/stores/common';

export default {
  data() {
    return {
      common: commonSpinner()
    };
  }
};
